/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeStatusOfProjectFinancialSummaryCommand } from '../../models/change-status-of-project-financial-summary-command';
import { ChangeStatusOfProjectFinancialSummaryCommandResult } from '../../models/change-status-of-project-financial-summary-command-result';

export interface ApiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost$Params {
      body?: ChangeStatusOfProjectFinancialSummaryCommand
}

export function apiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost(http: HttpClient, rootUrl: string, params?: ApiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ChangeStatusOfProjectFinancialSummaryCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChangeStatusOfProjectFinancialSummaryCommandResult>;
    })
  );
}

apiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost.PATH = '/api/ProjectFinancialSummaries/ChangeStatusOfProjectFinancialSummary';
